module.exports = __webpack_public_path__ + "static/media/ricky-1.a8693e17.jpeg";